/**
* author: duxin
* date: 2020/4/7
* describe: 关于我们
*/

<template>
       <router-view></router-view>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>